(function (angular) {
    angular.module('bizPartEngage').service('core.leaderboard.service', leaderboardService);

    leaderboardService.$inject = ["$http"];

    function leaderboardService($http) {
    	var servicePath = siteRootPath + "api/Leaderboards/";

    	this.GetGlobalLeaderboard = function (limit, startTime, endTime) {
    		var method = (startTime && endTime) ? "GetGlobalLeaderboardBetweenDates" : "GetGlobalLeaderboard";
    		return $http.get(servicePath + method, {
    			params: {
    				limit: limit,
    				startTime: startTime,
    				endTime: endTime
    			}
    		});
    	}

    	this.GetCountryLeaderboard = function (limit, startTime, endTime) {
    		var method = (startTime && endTime) ? "GetCountryLeaderboardBetweenDates" : "GetCountryLeaderboard";
    		return $http.get(servicePath + method, {
    			params: {
    				limit: limit,
    				startTime: startTime,
    				endTime: endTime
    			}
    		});
    	}

        this.GetMainUnitLeaderboard = function (limit) {
            return $http.get(siteRootPath + 'api/Leaderboards/GetMainUnitLeaderboard?' + $.param({ limit: limit }));
        };

        this.GetMainUnitLeaderboardBetweenDates = function (limit, startTime, endTime) {
            return $http.get(siteRootPath + 'api/Leaderboards/GetMainUnitLeaderboardBetweenDates?' + $.param({ limit: limit, startTime: startTime, endTime: endTime }));
        };

        this.GetUnitLeaderboard = function (limit) {
            return $http.get(siteRootPath + 'api/Leaderboards/GetUnitLeaderboard?' + $.param({ limit: limit }));
        };

        this.GetUnitLeaderboardBetweenDates = function (limit, startTime, endTime) {
            return $http.get(siteRootPath + 'api/Leaderboards/GetUnitLeaderboardBetweenDates?' + $.param({ limit: limit, startTime: startTime, endTime: endTime }));
        };
    }
})(window.angular);
